import { txList, getTxCount } from '@/config/apiServer/esdb'
import QRCode from 'qrcodejs2'
import { ref, reactive, Ref, ComputedRef } from 'vue'
import { TxType, PageType } from '@/types/types'

interface MixinsType {
  code: Ref<unknown>,
  txs: { list: TxType[], txType: number, loading: boolean },
  pages: PageType,
  options: string[],
  filterTrade: (type: number) => Promise<void>,
  getTrades: (match?: Array<any>, match_one?: Array<any>) => Promise<TxType[]>,
  getTradesCount: (match?: Array<any>, match_one?: Array<any>) => Promise<number>,
  pageChange: (page: number) => Promise<void>,
  sizeChange: (size: number) => Promise<void>,
  drawCode: () => void,
  makeCode: () => void,
  downCode: () => void,
  init: () => void
}

export default (adr: ComputedRef): MixinsType => {
  let code = ref()
  const txs = reactive({
    list: [] as TxType[],
    txType: 0,
    loading: false
  })
  const pages = reactive({
    number: 1,
    size: 10,
    total: 0
  })
  const options = ['全部数据', '查看成功的数据', '查看失败的数据', '查看发出的数据', '查看接收的数据']
  let match = [] as any[]
  let match_one = [{ key: "from", value: adr.value }, { key: "to", value: adr.value }]

  function init() {
    pages.number = 1
    txs.txType = 0
    match = []
    match_one = [{ key: "from", value: adr.value }, { key: "to", value: adr.value }]
  }

  async function filterTrade(type: number): Promise<void> {
    match = []
    match_one = [{ key: "from", value: adr.value }, { key: "to", value: adr.value }]
    switch (type) {
      case 1:
        match = [{ "query": { "match_one": [{ "key": "success", "value": true }, { key: "is_para", value: true }] } }]
        break;
      case 2:
        match = [{ key: "success", value: false }, { key: "is_para", value: false }]
        break;
      case 3:
        match_one = [{ key: "from", value: adr.value }]
        break;
      case 4:
        match_one = [{ key: "to", value: adr.value }]
        break;
      default:
        break;
    }
    pages.number = 1
    txs.list = await getTrades(match, match_one) || []
    pages.total = await getTradesCount(match, match_one)
  }

  async function getTrades(match?: Array<any>, match_one?: Array<any>): Promise<TxType[]> {
    txs.loading = true
    const params = [{
      match_one: match_one ? match_one : [{ key: "from", value: adr.value }, { key: "to", value: adr.value }],
      match: match ? match : [],
      "sort": [{
        "key": "height",
        "ascending": false
      }],
      page: pages
    }]
    const res = await txList(params)
    txs.loading = false
    return res.result
  }

  async function getTradesCount(match?: Array<any>, match_one?: Array<any>): Promise<number> {
    const params = [{
      match_one: match_one ? match_one : [{ value: adr.value, key: "from" }, { value: adr.value, key: "to" }],
      match: match ? match : []
    }]
    const res = await getTxCount(params)
    return res.result
  }

  async function pageChange(page: number): Promise<void> {
    pages.number = page
    txs.list = await getTrades(match, match_one)
  }
  async function sizeChange(size: number): Promise<void> {
    pages.size = size
    pages.number = 1
    txs.list = await getTrades(match, match_one)
  }

  function drawCode(): void {
    code = new QRCode('qrcode', {
      width: 100,
      height: 100,
      text: adr.value
    })
  }
  function makeCode(): void {
    (code as any).makeCode(adr.value)
  }
  function downCode(): void {
    const imgs = (document.getElementById("qrcode") as HTMLDivElement).getElementsByTagName("img")
    const a = document.createElement('a')
    a.download = `code${new Date().getTime()}.png`
    a.href = imgs[0].src
    const url = (document.getElementById("qrcode") as HTMLDivElement).getElementsByTagName("img")[0].src
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return { filterTrade, getTrades, getTradesCount, pageChange, sizeChange, txs, pages, options, drawCode, makeCode, downCode, code, init }
}